class DeliveryCountdown extends HTMLElement {
  connectedCallback() {
    this.cutoffHour = Number(this.dataset.cutoffHour ?? 13);
    this.cutoffMinute = Number(this.dataset.cutoffMinute ?? 0);
    this.deliveryHour = Number(this.dataset.deliveryHour ?? 16);
    this.deliveryMinute = Number(this.dataset.deliveryMinute ?? 0);

    this.activeEl = this.querySelector('[data-countdown-active]');
    this.expiredEl = this.querySelector('[data-countdown-expired]');
    this.timerEl = this.querySelector('[data-countdown-timer]');
    this.labelEl = this.querySelector('[data-countdown-label]');

    this.tick();
    this.interval = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.interval);
  }

  /** @returns {Date} */
  #nowInIstanbul() {
    const iso = new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Istanbul' });
    return new Date(iso.replace(' ', 'T'));
  }

  /** @param {Date} date @param {number} hour @param {number} minute */
  #setTime(date, hour, minute) {
    date.setHours(hour, minute, 0, 0);
    return date;
  }

  /** @param {number} ms */
  #formatRemaining(ms) {
    if (ms <= 0) return '';

    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return `${hours} saat ${minutes} dakika`;
    }

    if (minutes > 0) {
      return `${minutes} dakika ${seconds} saniye`;
    }

    return `${seconds} saniye`;
  }

  /** @param {number} hour @param {number} minute */
  #formatClock(hour, minute) {
    return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
  }

  tick() {
    const now = this.#nowInIstanbul();
    const cutoff = this.#setTime(new Date(now), this.cutoffHour, this.cutoffMinute);
    const remaining = cutoff.getTime() - now.getTime();
    const deliveryTime = this.#formatClock(this.deliveryHour, this.deliveryMinute);
    const cutoffTime = this.#formatClock(this.cutoffHour, this.cutoffMinute);

    if (remaining <= 0) {
      if (this.activeEl) this.activeEl.hidden = true;
      if (this.expiredEl) this.expiredEl.hidden = false;
      return;
    }

    if (this.activeEl) this.activeEl.hidden = false;
    if (this.expiredEl) this.expiredEl.hidden = true;

    const formatted = this.#formatRemaining(remaining);

    if (this.timerEl) {
      this.timerEl.textContent = formatted;
    }

    if (this.labelEl) {
      this.labelEl.textContent = `${deliveryTime}'a kadar teslimat için son`;
    }
  }
}

if (!customElements.get('delivery-countdown')) {
  customElements.define('delivery-countdown', DeliveryCountdown);
}
